import script from "./AddNewWebsite.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewWebsite.vue?vue&type=script&setup=true&lang=js"

import "./AddNewWebsite.vue?vue&type=style&index=0&id=747870f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747870f3"]])

export default __exports__